import axios from "axios";

const BASE_URL = "https://eventbackend.calypsu.com/";

export const axiosClient = axios.create({
  baseURL: BASE_URL,
});
